









import { Component, Prop, Vue, Watch } from "vue-property-decorator";

// @Component({

// })

@Component({
    components: {},
})
export default class Pill extends Vue {
    @Prop() type!: string;
}
